module.exports = "<div class=\"row wrapper border-bottom white-bg page-heading\"> <div class=col-sm-4> <h2>Map/group spent time</h2> <ol class=breadcrumb> <li> <a ui-sref=root.home>Home</a> </li> <li> Improve time reports </li> <li class=active> <strong>Map/group spent time</strong> </li> </ol> </div> <div class=col-sm-8> <div class=title-action> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/2-time/connect-and-refine.overview.html
// module id = 4075
// module chunks = 86